import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Identification } from './components/Identification';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Product } from './components/Product';
import { Benefits } from './components/Benefits';
import { Differentiation } from './components/Differentiation';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Objection } from './components/Objection';
import { Closing } from './components/Closing';
import { SocialProofPopup } from './components/SocialProofPopup';
import { StickyMobileCTA } from './components/StickyMobileCTA';
/*
 * TODO: META PIXEL INTEGRATION
 *
 * To activate Meta Pixel tracking:
 * 1. Replace 'YOUR_PIXEL_ID' below with your actual Meta Pixel ID
 * 2. Uncomment the useEffect hook
 *
 * Example:
 * useEffect(() => {
 *   (function(f,b,e,v,n,t,s) {
 *     if(f.fbq)return;n=f.fbq=function(){n.callMethod?
 *     n.callMethod.apply(n,arguments):n.queue.push(arguments)};
 *     if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
 *     n.queue=[];t=b.createElement(e);t.async=!0;
 *     t.src=v;s=b.getElementsByTagName(e)[0];
 *     s.parentNode.insertBefore(t,s)
 *   })(window, document,'script',
 *   'https://connect.facebook.net/en_US/fbevents.js');
 *   fbq('init', 'YOUR_PIXEL_ID');
 *   fbq('track', 'PageView');
 * }, []);
 */
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Identification data-id="element-2" />
      <Problem data-id="element-3" />
      <Solution data-id="element-4" />
      <Product data-id="element-5" />
      <Benefits data-id="element-6" />
      <Differentiation data-id="element-7" />
      <Testimonials data-id="element-8" />
      <Pricing data-id="element-9" />
      <Objection data-id="element-10" />
      <Closing data-id="element-11" />

      <SocialProofPopup data-id="element-12" />
      <StickyMobileCTA data-id="element-13" />
    </div>;
}